import Popover from "@mui/material/Popover"
import { DateCalendar } from "@mui/x-date-pickers"

export default function SelectDatePopover({
  anchorElem,
  onClose,
  currentDate,
  setCurrentDate,
}) {
  function handleDateChanged(newValue) {
    onClose()
    setCurrentDate(newValue)
  }

  return (
    <Popover
      open={Boolean(anchorElem)}
      anchorEl={anchorElem}
      onClose={onClose}
      anchorOrigin={{
        horizontal: "center",
        vertical: "center",
      }}
      transformOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
    >
      <DateCalendar value={currentDate} onChange={handleDateChanged} />
    </Popover>
  )
}
